import { render } from "./create.vue?vue&type=template&id=a2584bd0&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import "./create.vue?vue&type=style&index=0&id=a2584bd0&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/xz_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2584bd0"]])

export default __exports__